import { useApp } from "@/app/providers/app-provider";
import { Home, User, Library } from "lucide-react";
import { NavLink } from "react-router";

interface NavButtonProps {
	icon: React.ReactNode;
	label: string;
	to: string;
}

function NavButton({ icon, label, to }: NavButtonProps) {
	return (
		<NavLink
			to={to}
			className={({ isActive }) =>
				`flex flex-col items-center justify-center bg-brand h-full w-full rounded-none gap-0 ${isActive && "brightness-90"}`
			}
		>
			{icon}
			<span className="text-xs font-medium mt-1">{label}</span>
		</NavLink>
	);
}

export default function mobileNavbarBottom() {
	const { appStore } = useApp();

	return (
		<nav className="fixed bottom-0 left-0 right-0 border-t border-border">
			<div className="flex justify-around items-center h-16">
				<NavButton
					icon={<Home className="h-6 w-6" />}
					label="Home"
					to="/"
					// to={authStatus === "AUTHENTICATED" ? "/home" : "/"}
				/>
				<NavButton
					icon={<Library className="h-6 w-6" />}
					label="Library"
					to="/library"
				/>
				<NavButton
					icon={<User className="h-6 w-6" />}
					label={appStore.session ? "Account" : "Log In"}
					to={appStore.session ? "/account" : "/auth/log-in"}
				/>
			</div>
		</nav>
	);
}
